import * as React from 'react'

import 'whatwg-fetch'

import { Form, FormGroup, FormControl, ControlLabel, Row, Button, HelpBlock } from 'react-bootstrap'
import { History } from 'history'
import { isEmail } from 'class-validator'
import { captureExceptionWithSentry } from '../sentry'

interface PasswordRecoveryContainerState {
	username: string
	validationMessage: string
	validationState: 'success' | 'error' | undefined
	sendBtnStatus: boolean
}

interface PasswordRecoveryContainerProps {
	history: History
}

class PasswordRecoveryContainer extends React.Component<
	PasswordRecoveryContainerProps,
	PasswordRecoveryContainerState
> {
	constructor(props: PasswordRecoveryContainerProps) {
		super(props)
		this.state = {
			username: '',
			validationMessage: '',
			validationState: undefined,
			sendBtnStatus: false,
		}
		this.setEmail = this.setEmail.bind(this)
		this.sendEmailForPasswordRecovery = this.sendEmailForPasswordRecovery.bind(this)
		this.formPreventDefault = this.formPreventDefault.bind(this)
	}

	public formPreventDefault(e: React.FormEvent<HTMLInputElement>): void {
		e.preventDefault()
	}

	public setEmail(e: any): void {
		// console.log('e', e.currentTarget.value)
		this.setState({
			username: e.target.value,
			validationMessage: '',
			validationState: undefined,
		})
	}

	public async sendEmailForPasswordRecovery(e: React.FormEvent<HTMLInputElement>) {
		e.preventDefault()

		if (isEmail(this.state.username)) {
			this.setState({
				// validationMessage: "Thank you! Please allow a few minutes for your password recovery email.",
				validationState: 'success',
				sendBtnStatus: true,
			})
			const headers = new Headers()
			headers.append('Accept', 'application/json')
			headers.append('Content-Type', 'application/json')
			try {
				const response = await fetch('/users/startProcessForPasswordrecovery', {
					method: 'POST',
					credentials: 'same-origin',
					headers,
					body: JSON.stringify(this.state),
				})
				if (!response.ok) {
					throw new Error(response.statusText)
				}
				this.props.history.push({
					pathname: '/users/passwordRecovery/thankyou',
					state: { username: this.state.username },
				})
				// location.href = `/users/passwordRecovery/thankyou/${encodeURIComponent(this.state.username)}`
			} catch (error) {
				captureExceptionWithSentry(error)
				// console.error('Request failed', error)
			}
		} else if (this.state.username) {
			this.setState({
				validationMessage: 'Invalid email.',
				validationState: 'error',
			})
		}
	}
	public render() {
		const hStyle: React.CSSProperties = {
			textAlign: 'center',
		}
		return (
			<div>
				<Row>&nbsp;</Row>
				<Row>&nbsp;</Row>

				<h4 style={hStyle}>Forgot your password?</h4>
				<h4 style={hStyle}>Enter your email below and we'll send you an email shortly.</h4>

				<Row>&nbsp;</Row>
				<Row>&nbsp;</Row>

				<Form onSubmit={(e) => this.formPreventDefault(e as any)}>
					<FormGroup validationState={this.state.validationState}>
						<ControlLabel>E-Mail Address</ControlLabel>
						<FormControl
							type="email"
							value={this.state.username}
							onChange={(e) => this.setEmail(e as any)}
							placeholder="E-Mail Address"
							data-test="email"
						/>
						<HelpBlock>
							<strong>{this.state.validationMessage}</strong>
						</HelpBlock>
					</FormGroup>

					<Button
						bsStyle="primary"
						onClick={(e) => this.sendEmailForPasswordRecovery(e as any)}
						block
						disabled={this.state.sendBtnStatus}
						data-test="continue"
					>
						Continue
					</Button>
				</Form>

				<Row>&nbsp;</Row>
				<Row>&nbsp;</Row>
			</div>
		)
	}
}
export default PasswordRecoveryContainer as React.ComponentClass<PasswordRecoveryContainerProps>
